import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { WindowHelperService } from '@anecdotes/utils';

export const stateKey = 'state';
export const origStateKey = 'origState';
export const redirectOriginKey = 'redirectOrigin';

@Component({
  selector: 'app-plugin-redirection-callback',
  template: '',
  standalone: false,
})
export class PluginRedirectionCallbackComponent implements OnInit {
  constructor(private activatedRoute: ActivatedRoute, private windowHelperService: WindowHelperService) {}

  ngOnInit(): void {
    const queryParams = { ...this.activatedRoute.snapshot.queryParams };
    const stateString = queryParams[stateKey];
    const stateObject = JSON.parse(this.windowHelperService.getWindow().atob(stateString));
    queryParams[stateKey] = stateObject[origStateKey];
    const stringifiedQueryParams = Object.keys(queryParams)
      .filter((key) => queryParams[key])
      .map((key) => `${key}=${queryParams[key]}`)
      .join('&');

    const url = `${stateObject[redirectOriginKey]}${
      this.windowHelperService.getWindow().location.pathname
    }?${stringifiedQueryParams}`;
    this.windowHelperService.openUrl(url);
  }
}
